import { createAsyncThunk } from '@reduxjs/toolkit';

// Store entities & slices
import { openNotification } from '../app-notifications/app-notifications.thunks';
import { PaymentsSliceActions } from './payments.slice';

// Services
import { PaymentsService } from '../../services/payments.service';

// Models
import { ICreateDefaultPayment } from '../../interfaces/payments.interfaces';
import { ELocalStorageKeys } from "../../enums/storage.enums";

// Create the middleware instance and methods
export enum EPaymentsThunks {
  FetchPaymentsCards = 'PAYMENTS/fetchPaymentsCards',
  DeletePaymentCard = 'PAYMENTS/deletePaymentCard',
  SelectPaymentCard = 'PAYMENTS/selectPaymentCard',
  CreatePaymentCard = 'PAYMENTS/createPaymentCard',
  PayExistingPaymentCard = 'PAYMENTS/payExistingPaymentCard',
}

export const fetchPaymentsCards = createAsyncThunk(
  EPaymentsThunks.FetchPaymentsCards,
  async (_, { dispatch }) => {
    dispatch(PaymentsSliceActions.loadPaymentsRequest());
    const { error, data } = await PaymentsService.fetchPaymentCards();
    if (!data) {
      dispatch(openNotification({ type: 'error', description: error }))
      return dispatch(PaymentsSliceActions.loadPaymentsRequestError());
    }
    return dispatch(PaymentsSliceActions.loadPaymentsRequestSuccess(data));
  }
);

export const deletePaymentCard = createAsyncThunk(
  EPaymentsThunks.DeletePaymentCard,
  async (token: string, { dispatch }) => {
    const { error, selected_card, message } = await PaymentsService.deletePaymentCard(token);
    if (error) {
      return dispatch(openNotification({ type: 'error', description: error }));
    }
    dispatch(openNotification({ type: 'success', description: message }));
    return dispatch(PaymentsSliceActions.deleteCard({ selected_card, deleted_card: token }));
  }
);

export const selectPaymentCard = createAsyncThunk(
  EPaymentsThunks.SelectPaymentCard,
  async (token: string, { dispatch }) => {
    const { error, selected_card, message } = await PaymentsService.selectPaymentCard(token);
    if (!selected_card) {
      return dispatch(openNotification({ type: 'error', description: error }));
    }
    dispatch(openNotification({ type: 'success', description: message }));
    return dispatch(PaymentsSliceActions.markDefault({ selected_card }));
  }
);

export const createPaymentCard = createAsyncThunk(
  EPaymentsThunks.CreatePaymentCard,
  async ({ si }: { si: string }, { dispatch }) => {
    const { error, card } = await PaymentsService.createPaymentCard(si);
    if (!card) {
      dispatch(openNotification({ type: 'error', description: error }));
      return null;
    }
    const temporary_token = localStorage.getItem(ELocalStorageKeys.TemporaryToken);
    if (!temporary_token) {
      dispatch(PaymentsSliceActions.addNewCard({ card }));
    }
    return card;
  }
);

export const payExistingPaymentCard = createAsyncThunk(
  EPaymentsThunks.PayExistingPaymentCard,
  async (createPayment: ICreateDefaultPayment) => {
    const { data, error } = await PaymentsService.payExistingPaymentCard(createPayment);
    if (!data) {
      return { error };
    }
    return { data };
  }
);

